import React from 'react';

export default function HomeFloatingContact() {
  return (
    <aside className="floating-contact" aria-label="Quick contact links">
      <a href="tel:+919884211885" aria-label="Call DALMAF">
        <svg viewBox="0 0 24 24">
          <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7a2 2 0 0 1 1.7 2Z" />
        </svg>
      </a>
      <a href="https://wa.me/919884211885" aria-label="Message DALMAF on WhatsApp">
        <svg viewBox="0 0 24 24">
          <path d="M20 11.6a8 8 0 0 1-11.8 7l-4.2 1.1 1.1-4A8 8 0 1 1 20 11.6Z" />
          <path d="M9.2 8.3c.2-.5.4-.5.7-.5h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4-.1.6l-.4.5c-.1.1-.2.3-.1.5.3.6.8 1.2 1.3 1.6.6.5 1.1.8 1.8 1 .2.1.3 0 .5-.1l.7-.8c.2-.2.4-.2.6-.1l1.5.7c.2.1.4.3.4.5 0 .5-.3 1.3-.7 1.7-.5.4-1.4.6-2.9.1-2.4-.8-4.4-2.8-5.3-4.9-.5-1.1-.5-2.1-.2-2.8Z" />
        </svg>
      </a>
      <a href="mailto:info@dalmaf.com" aria-label="Email DALMAF">
        <svg viewBox="0 0 24 24">
          <path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
          <path d="m22 7-10 6L2 7" />
        </svg>
      </a>
    </aside>
  );
}
